export const TaxYear = ["2024","2023"]

export const FormType = [
    { value: "4", key: "Form W-2" },
    { value: "68",key: "Form 1099 NEC" },
    { value: "1", key: "Form 1099 MISC" },
    { value: "2", key: "Form 1099 INT" },
    { value: "3", key: "Form 1099 DIV" },
    { value: "7", key: "Form 1099 R" },
]

export const TINTypes = [
    { value: "EIN", key: "EIN" },
    { value: "SSN", key: "SSN" },
]